import { useMemo } from 'react';

import { ConsumerStudentFee } from '@givebacks/api/student';
import { ThemeIcon, ThemeIconProps } from 'ui';
import { ICON_API_MAP, IconReceipt } from 'ui/Icons';

const FeeImage = ({
  icon,
  // eslint-disable-next-line id-length
  c = 'gray.4',
  children,
}: {
  icon?: ConsumerStudentFee['fee']['icon'];
  c?: ThemeIconProps['c'];
  children?: React.ReactNode;
}) => {
  const Icon = useMemo(() => {
    if (!icon || !ICON_API_MAP[icon]) return IconReceipt;
    return ICON_API_MAP[icon];
  }, [icon]);

  return (
    <ThemeIcon
      size="64px"
      color="gray.1"
      c={c}
      style={{ flex: 0, alignSelf: 'flex-start' }}
      radius="sm"
    >
      {children ? children : <Icon size={32} />}
    </ThemeIcon>
  );
};

export { FeeImage };
